import React from 'react';
import { LightgalleryItem } from 'react-lightgallery';

const ImageItem = ({ image, thumb, alt, group }) => (
  <div style={{ maxWidth: '250px', width: '200px', padding: '5px' }}>
    <LightgalleryItem group={group} src={image} thumb={thumb}>
      <img src={image} style={{ width: '100%' }} alt={alt} />
    </LightgalleryItem>
  </div>
);

export default ImageItem;
